import * as React from 'react';
import { isNil } from '@hawkins/helpers';
import { IconCaretDown } from '@hawkins/icons/lib/iconCaretDown';
import { IconCaretUp } from '@hawkins/icons/lib/iconCaretUp';
import { MenuTriggerContext } from '../menu';
import { useId } from './useId';
/**
 * A hook that can execute [Menu](/components-menu) trigger logic for a component.
 *
 * TODO(API): Write docs and tests and expose to Hawkins consumers.
 *
 * @private
 */
export function useMenuTrigger(_a) {
    var defaultTriggerId = _a.defaultTriggerId, triggerIdNamespace = _a.triggerIdNamespace;
    var triggerId = useId(triggerIdNamespace, { defaultId: defaultTriggerId });
    var menuTriggerContext = React.useContext(MenuTriggerContext);
    var caretDirectionClosed = menuTriggerContext.caretDirectionClosed, menuId = menuTriggerContext.menuId, open = menuTriggerContext.open, setTriggerId = menuTriggerContext.setTriggerId, showCaret = menuTriggerContext.showCaret;
    var isTrigger = !isNil(open);
    var triggerAriaAttributes = {};
    if (open) {
        triggerAriaAttributes['aria-expanded'] = true;
        if (menuId)
            triggerAriaAttributes['aria-controls'] = menuId;
    }
    if (isTrigger)
        triggerAriaAttributes['aria-haspopup'] = 'menu';
    // Connect the menu and its trigger by `id` for accessibility.
    React.useEffect(function () {
        setTriggerId(triggerId);
    }, [setTriggerId, triggerId]);
    return {
        CaretIcon: isTrigger && showCaret
            ? open
                ? caretDirectionClosed === 'up'
                    ? IconCaretDown
                    : IconCaretUp
                : caretDirectionClosed === 'up'
                    ? IconCaretUp
                    : IconCaretDown
            : null,
        menuTriggerContext: menuTriggerContext,
        triggerAriaAttributes: triggerAriaAttributes,
        triggerId: triggerId,
    };
}
